import { render, staticRenderFns } from "./personalCenter.vue?vue&type=template&id=2fb4bb4b&scoped=true"
import script from "./personalCenter.vue?vue&type=script&lang=js"
export * from "./personalCenter.vue?vue&type=script&lang=js"
import style0 from "./personalCenter.vue?vue&type=style&index=0&id=2fb4bb4b&prod&lang=css"
import style1 from "./personalCenter.vue?vue&type=style&index=1&id=2fb4bb4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb4bb4b",
  null
  
)

export default component.exports